<template>
    <div class="container">
        <div class="top-wrapper">
            <div class="nav-item" id="left-nav-item" @click="goSettingIndex">
                <img src="../../../assets/image/seller/icon_setting_nor.png" class="nav-icon">
            </div>
            <div class="nav-item" id="right-nav-item" @click="goNews()">
                <img src="../../../assets/image/seller/icon_news_nor.png" class="nav-icon">
                <span v-if="0"></span>
            </div>
            <div class="top-info-wrapper">
                <div class="avatar-wrapper" @click="goSettingIndex">
                    <img class="avatar" v-bind:src="store_info.store_avatar" v-if="isOnline && seller && store_info.store_avatar"/>
                </div>
                <label class="sellername" style="-webkit-box-orient:vertical" @click="goSettingIndex">{{sellername}}</label>
            </div>
        </div>
        <div class="order-header" @click="goSellerorder('')">
            <div class="order-header-item" id="order-item-left">
                <label class="item-title order-header-title">订单管理</label>
            </div>
            <div class="order-header-item" id="order-item-right">
                <label class="order-subtitle">查看全部订单</label>
                <i class="indicator iconfont">&#xe650;</i>
            </div>
            <div class="order-header-line"></div>
        </div>
        <div class="order-wrapper">
            <index-order-item
                    class="order-item"
                    v-on:onclick="goSellerorder('state_new')"
                    :src="require('../../../assets/image/seller/icon_pay_seller_nor.png')"
                    title="待付款"
                    :orderNumber = 'seller_info.order_nopay_count'>
            </index-order-item>
            <index-order-item
                    class="order-item"
                    v-on:onclick="goSellerorder('state_pay')"
                    :src="require('../../../assets/image/seller/icon_good_seller_nor.png')"
                    title="待接单"
                    :orderNumber = 'seller_info.order_noship_count'>
            </index-order-item>
            <index-order-item
                    class="order-item"
                    v-on:onclick="goSellerorder('state_receipt')"
                    :src="require('../../../assets/image/seller/icon_consignee_seller_nor.png')"
                    title="待派单"
                    :orderNumber = 'seller_info.order_noreceipt_count'>
            </index-order-item>

        </div>
		<div class="manage-wrapper mt-5">
		    <index-manage-item
		            v-on:onclick="goGoodsonline"
		            :src="require('../../../assets/image/seller/icon_goods_seller_nor.png')"
		            title="商品管理">
		    </index-manage-item>
		    <index-manage-item
		            v-on:onclick="goGoodsclass"
		            :src="require('../../../assets/image/seller/icon_classify_seller_pre.png')"
		            title="店铺分类">
		    </index-manage-item>
		    <index-manage-item
		            v-on:onclick="goGoodsspec"
		            :src="require('../../../assets/image/seller/icon_specifications_seller_pre.png')"
		            title="商品规格">
		    </index-manage-item>
		    <index-manage-item
		            v-if="!seller.is_platform_store"
		            v-on:onclick="goMoney"
		            :src="require('../../../assets/image/seller/icon_capital_seller_pre.png')"
		            title="店铺资金">
		    </index-manage-item>
		    <index-manage-item
		            v-if="!seller.is_platform_store"
		            v-on:onclick="goDeposit"
		            :src="require('../../../assets/image/seller/icon_deposit_seller_pre.png')"
		            title="店铺保证金">
		    </index-manage-item>
		    <index-manage-item
		            v-on:onclick="goSellerbill"
		            :src="require('../../../assets/image/seller/icon_settle_seller_pre.png')"
		            title="结算管理">
		    </index-manage-item>
		    <index-manage-item
		            v-on:onclick="goSellerRefundList"
		            :src="require('../../../assets/image/seller/icon_refunds_seller_pre.png')"
		            title="退款管理">
		    </index-manage-item>
		</div>
        <div class="bottom-wrapper mt-5">
            <index-info-item
                    v-if="config && config.dada_open=='1' && store_info.store_o2o_distribute_type==0 && config.o2o_open=='1' && ((!store_info.is_platform_store && store_info.store_o2o_support==1) || store_info.is_platform_store)"
                    v-on:onclick="goDada"
                    :src="require('../../../assets/image/seller/icon_shop_seller_nor.png')"
                    title="达达门店">
            </index-info-item>
            <index-info-item
                    v-on:onclick="goSellerEvaluateList"
                    :src="require('../../../assets/image/seller/icon_judge_seller_nor.png')"
                    title="评价管理">
            </index-info-item>
            <index-info-item
                    v-on:onclick="goAccount"
                    :src="require('../../../assets/image/seller/icon_person_seller_nor.png')"
                    title="子账户管理">
            </index-info-item>
            <index-info-item
                    v-on:onclick="goSellerInviter"
                    :src="require('../../../assets/image/seller/icon_retail_nor.png')"
                    title="店铺分销">
            </index-info-item>
            <index-info-item
                    v-on:onclick="goSellerStatisticsGeneral"
                    :src="require('../../../assets/image/seller/icon_count_seller_nor.png')"
                    title="店铺概况统计">
            </index-info-item>
        </div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import IndexInfoItem from './IndexInfoItem'
import IndexOrderItem from './IndexOrderItem'
import IndexManageItem from './IndexManageItem'
import { getSellerInfo } from '../../../api/seller'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'Index',
  data () {
    return {
      store_info: {},
      seller_info: {},
      statics: {}
    }
  },
  components: {
    IndexInfoItem,
    IndexOrderItem,
	IndexManageItem
  },
  created: function () {
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    if (this.isOnline) {
      getSellerInfo().then(response => {
        if (response && response.result) {
          this.seller_info = response.result.seller_info
          this.store_info = response.result.store_info
          this.statics = response.result.statics
        }
      }
      ).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config,
      isOnline: state => state.seller.isOnline,
      seller: state => state.seller.info
    }),
    sellername () {
      let title = '登录/注册'
      if (this.isOnline) {
        if (this.seller && typeof this.seller !== 'undefined' && JSON.stringify(this.seller) !== '{}') {
          title = this.seller.seller_name
        }
      }
      return title
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    }),
    ...mapMutations({
      memberUpdate: 'memberUpdate'
    }),
    goDada () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerDadaShop' })
      } else {
        this.showLogin()
      }
    },
    showLogin () {
      this.$router.push({ name: 'HomeSellerLogin' })
    },
    // 店铺资金 普通店铺显示
    goMoney () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerMoney' })
      } else {
        this.showLogin()
      }
    },
    // 店铺保证金 普通店铺显示
    goDeposit () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerDeposit' })
      } else {
        this.showLogin()
      }
    },
    // 店铺设置
    goSettingIndex () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerSettingIndex' })
      } else {
        this.showLogin()
      }
    },
    goNews () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerNoticeList' })
      } else {
        this.showLogin()
      }
    },
    // 子账户管理
    goAccount () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerAccount' })
      } else {
        this.showLogin()
      }
    },
    // 店铺分类
    goGoodsclass () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerGoodsClassList' })
      } else {
        this.showLogin()
      }
    },
    // 商品管理
    goGoodsonline () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerGoodsonline' })
      } else {
        this.showLogin()
      }
    },
      // 商品规格
      goGoodsspec () {
          if (this.isOnline) {
              this.$router.push({ name: 'SellerSpec' })
          } else {
              this.showLogin()
          }
      },
    // 订单列表
    goSellerorder (state) {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerOrderList', query: { state: state } })
      } else {
        this.showLogin()
      }
    },
    // 退款管理
    goSellerRefundList () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerRefundList' })
      } else {
        this.showLogin()
      }
    },
    // 评价管理
    goSellerEvaluateList () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerEvaluateList' })
      } else {
        this.showLogin()
      }
    },

    // 订单结算
    goSellerbill () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerBillList' })
      } else {
        this.showLogin()
      }
    },
    // 店铺统计
    goSellerStatisticsGeneral () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerStatisticsGeneral' })
      } else {
        this.showLogin()
      }
    },
    // 店铺分销
    goSellerInviter () {
      if (this.isOnline) {
        this.$router.push({ name: 'SellerInviter' })
      } else {
        this.showLogin()
      }
    }
  }

}
</script>

<style scoped lang='scss'>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #f0f2f5;
    .top-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        height: 8rem;
        background: $primaryColor;
    .top-info-wrapper {
        flex: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    }
    .nav-item {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.2rem;
        height: 2.2rem;
        top: 0.55rem;
    span {
        width: 0.35rem;
        height: 0.35rem;
        background-color: #f0f2f5;
        border-radius: 50%;
        position: absolute;
        top: 0.55rem;
        right: 0.55rem;
    }
    }
    #left-nav-item {
        left: 0.5rem;
    }
    #right-nav-item {
        right: 0.5rem;
    }
    .nav-icon {
        width: 1.3rem;
        height: 1.3rem;
        text-align: center;
        color: #fff;
    }
    .avatar-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 3.8rem;
        height: 3.8rem;
        border-radius: 1.9rem;
        background-color: #fff;
        margin-top: 2rem;
    .avatar {
        width: 3.6rem;
        height: 3.6rem;
        border-radius: 1.8rem;
    }
    }
    .sellername {
        width: 100%;
        margin-top: 1rem;
        font-size: 0.8rem;
        color:rgba(255,255,255,1);
        text-align: center;
        margin-left: 0;
        margin-right: 0;
    }
    .info-wrapper {
        width: 100%;
        height: 2rem;
        display: inline-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-content: stretch;
        background-color: rgba(0, 0, 0, 0.1);
    }
    .info-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size:.8rem;
    }
    .order-header {
        height: 2.2rem;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-content: stretch;
        background-color: #fff;
    }
    .order-header-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    #order-item-left {
        justify-content: flex-start;
        margin-left: 0.5rem;
    }
    #order-item-right {
        justify-content: flex-end;
    }
    .order-header-line {
        position: absolute;
        height: 1px;
        left: 0.5rem;
        bottom: 0;
        right: 0.5rem;
        background-color: #E8EAED;
    }
    .item-title {
        font-size:$subFontSize;
        color: #333;
        font-weight:700;
    }
    .order-header-icon {
        width: 0.9rem;
        height: 0.9rem;
    }
    .order-header-title {
        margin-left: 0.4rem;
    }
    .indicator {
        width: 0.35rem;
        height: 0.6rem;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }
    .order-subtitle {
        font-size: 0.6rem;
        color: #999999;
    }
    .order-wrapper {
        height: 4.4rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: #fff;
    }
    .order-item {
        flex: 1;
    }
        .bottom-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            margin-bottom: 3rem;
        }
		.manage-wrapper{background:#fff;}
    }
</style>
